<template>
  <div>
    <div class="inspection-issues-header">
      <div class="inspection-issues-title">
        <span>
          {{ $l('drawer_title_inspection_issues_not_pass') || '不良原因选择' }}
        </span>
      </div>

      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('btn_inspection_issues_not_pass_confirm') || '确认添加' }}
      </el-button>
    </div>

    <div class="inspection-issues-content">
      <el-checkbox-group v-model="selected">
        <div
          v-for="item in list"
          :key="item.defectIssuesGroup"
          class="inspection-issues-group"
        >
          <div class="inspection-issues-group-title">
            {{ item.defectIssuesGroup }}
          </div>
          <div class="inspection-issues-group-items">
            <el-checkbox
              v-for="item in item.items"
              :key="item.defectIssuesTitle"
              :label="item.defectIssuesTitle"
              :value="item.defectIssuesTitle"
            >
              {{ item.defectIssuesTitle }}
            </el-checkbox>
          </div>
        </div>
      </el-checkbox-group>
    </div>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="confirm()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import lodash from 'lodash'
export default {
  data() {
    return {
      list: [],
      selected: [],
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const res = await this.$api
        .inspectionDefectIssuesListApi({ issueType: 'inspection' })
        .catch(() => null)
      if (!res) return

      const data = res.body?.data || []

      this.list = lodash.mapValues(
        lodash.groupBy(data, 'defectIssuesGroup'),
        (items) => {
          const { defectIssuesGroup } = items[0]
          return { defectIssuesGroup, items }
        },
      )
    },
    confirm() {
      if (lodash.isEmpty(this.selected)) {
        this.$message.warning(
          this.$l('tips_select_issue_reason') || '请选择不良原因',
        )
        return (this.backDialogVisible = false)
      }

      this.$emit('confirm', this.selected)
      this.$emit('close')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.inspection-issues-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;

  .inspection-issues-title {
    font-size: 16px;
    font-weight: 600;
    color: #071437;
  }
}

.inspection-issues-content {
  .inspection-issues-group {
    margin-bottom: 1.2rem;
    &:last-child {
      margin-bottom: 0;
    }

    .inspection-issues-group-title {
      font-size: 14px;
      font-weight: 600;
      color: #101010;
      margin-bottom: 12px;
    }

    .inspection-issues-group-items {
      display: flex;
      flex-wrap: wrap;
      gap: 12px 20px;

      :deep(.el-checkbox) {
        margin-right: 0;

        .el-checkbox__label {
          font-size: 13px;
          color: #333;
        }
      }
    }
  }
}
</style>
